    const productList = [
        {name:'QDM150',id:'9052329705707',series:'Mounts'},
        {name:'QDS150',id:'9102892466411',series:'Mounts'},
        
        {name:'ZHD520R-V2',id:'8945516839147',series:'ZULUS-V2'},
        {name:'ZHD520-V2',id:'8978016534763',series:'ZULUS-V2'},
        {name:'ZHD312R-V2',id:'8945517330667',series:'ZULUS-V2'},
        {name:'ZHD312-V2',id:'8978031116523',series:'ZULUS-V2'},
        {name:'ZHD312R',id:'8621796917483',series:'ZULUS'},

        {name:'HS225R',id:'9101608747243',series:'Hydra'},
        {name:'HS219',id:'9052318531819',series:'Hydra'},
        {name:'HS635R',id:'9103433171179',series:'Hydra'},
        {name:'HS635',id:'8791055040747',series:'Hydra'},
        {name:'HS650R',id:'9103433433323',series:'Hydra'},
        {name:'HS335',id:'9052328362219',series:'Hydra'},
        {name:'HS335R',id:'9103432515819',series:'Hydra'},
        {name:'HS225',id:'8791052878059',series:'Hydra'},
        {name:'HS325',id:'8791053598955',series:'Hydra'},

        {name:'TNC635R',id:'8788756529387',series:'ThermNight'},
        {name:'TNC335R',id:'8788755185899',series:'ThermNight'},
        {name:'TNC225R',id:'8621796491499',series:'ThermNight'},

        {name:'ADM-Mount',id:'8861432873195',series:'Mounts'},

        {name:'TheOne',id:'8740417274091',series:'TheOne'},

        {name:'H315R',id:'9001610739947',series:'HOUND'},
        {name:'H325R',id:'9001611165931',series:'HOUND'},
        {name:'H635R',id:'9001613557995',series:'HOUND'},
        
        {name:'NVMD-C200',id:'9116021194987',series:'NVMD'},
        {name:'QDF170',id:'9116021489899',series:'Mounts'},

        {name:'ZULUS 4K',id:'9284959895787',series:'ZULUS-4K'},

    ]
    const videoListData = [
        {
            name:'HOW TO',
            type:'HT',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/51b3H4zAROU?si=PQ2mAIFlWNv7_OQ1?enablejsapi=1&autoplay=1',
                    title:"How to Use One Tap Connect on ZULUS 4K | DNT Optics",
                    poster: 'https://i.ytimg.com/vi/51b3H4zAROU/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCVulFGLGGK5utXVYITOpI1iKr2WA',
                    id:'28',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"Connecting your ZULUS 4K with the DNT App just got easier.<br/>\
                                To use One Tap Connect, please ensure:<br/>\
                                ✅App Version: You have installed or updated to the DNT App v1.4.6 or later.<br/>\
                                ✅Bluetooth: Your phone’s Bluetooth is enabled.<br/>\
                                ✅Permissions: You have granted the DNT App permission to access Bluetooth in your mobile settings.",
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/hCyG2ZamggA?si=_HTOb3TRG1-mIkP2?enablejsapi=1&autoplay=1',
                    title:"How to Choose the QDS150 or QDM150 Mount | DNT Optics",
                    poster: 'https://i.ytimg.com/vi/hCyG2ZamggA/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCDSVepFaGI8yh0tmaZjhgtaQL2XA',
                    id:'27',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'Elevate your experience with the DNT Quick Detach system — QDS150 and QDM150.<br/>\
                    Both aircraft-grade aluminum mounts provide a 1.5" optical centerline with a secure, tool-less automatic locking mechanism.<br/>\
                    ✅ QDS150: Ultra-lightweight (2.93 oz) and streamlined for maximum portability. <br/>\
                    ✅ QDM150: Multi-functional with dual-sided flexibility for rifle or handheld use.<br/>\
                    Compatibility: Fits ThermNight, ZULUS HD, and HYDRA series. Note: Not compatible with early TNC225R models featuring a square mounting base.',
                    matchProduct:'QDS150,QDM150',
                    matchSeries:'Mounts',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/faY1QFO4wno?si=Fi8eFytPT1LnqE1w?enablejsapi=1&autoplay=1',
                    title:"QDS150 Quick Detach Mount | Universal Fit for All DNT Digital Scopes",
                    poster: 'https://i.ytimg.com/vi/faY1QFO4wno/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBqo4oJv_pgJPEVUSSiMed3fBqdRQ',
                    id:'26',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"Engineered at a 1.5″ opticheight for perfect eye alignment, it locks in solid and detaches instantly without losing zero. The QDS150 Quick Detach Mount brings fast, tool-free set up to all DNT Digital Scopes — including ThermNight, HYDRA, and ZULUS HD V1 & V2.",
                    matchProduct:'QDS150',
                    matchSeries:'Mounts',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/1YlJ1UJsoug?si=b83T7TfetXh7P1j5?enablejsapi=1&autoplay=1',
                    title:"Getting Started with the HOUND | From Unbox to Ballistic Sync",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/hound-youtubo-poster.webp?v=1765248554',
                    id:'25',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"This video covers the HOUND Ballistic Thermal Monocular from unboxing to full setup. It highlights the included accessories and shows how to connect to the DNT app, sync ballistic data, adjust focus, and navigate essential settings. ",
                    matchProduct:'H315R,H325R,H635R',
                    matchSeries:'HOUND',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/Md0KmSP13JE?si=XFZp8uB8CHW_Z9nR?enablejsapi=1&autoplay=1',
                    title:'Getting Started with ZULUS 4K | DNT Optics',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/fc7ab9440bf54c53af84b9391c8617be.webp?v=1769567432',
                    id:'24',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"Master your ZULUS 4K optic in minutes — This quick guide walks you through all the essentials in the settings menu, including zeroing, reticle selection, the DNT Ballistic Engine, and laser rangefinding.",
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS-4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/pXBYwdhKE8Y?si=w-Wu-RiciWAWwE9U?enablejsapi=1&autoplay=1',
                    title:'How to Properly Focus Your Thermal Sight',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/16f76702615b4f2bbdb24dfda301f7a5.webp?v=1768875643',
                    id:'23',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"This video explains how proper focus on your thermal optic ensures clear sight and precise targeting.",
                    matchProduct:'TNC635R',
                    matchSeries:'ThermNight,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/a8mSX8ME-9M?si=Y9outTtoa9B0Ff--?enablejsapi=1&autoplay=1',
                    title:'How to Pick the Right Base Magnification for Your Thermal Scope',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/177ea08d60af4b88855768d5376a58b0.webp?v=1768875445',
                    id:'22',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"If you’re choosing your first thermal scope for hunting and don’t know where to start, base magnification is a great place to begin. In this video, we break down what base magnification is, how it affects field of view and target clarity, and how to choose the base mag that best suits your needs.",
                    matchProduct:'TNC635R,TNC335R,HS650R',
                    matchSeries:'ThermNight,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/8Cyek9-72M8?si=6PqCvq0n1jjj-mel?enablejsapi=1&autoplay=1',
                    title:'How to Avoid the Most Common One-Shot Zero Mistake When Sighting In Your Scope',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/d7eb83d2e56d4f4181ff823bcfa0ea70.webp?v=1766728763',
                    id:'21',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"In this video, we cover a common one-shot zero mistake and show the right way to adjust your reticle with a DNT Scope. Simple tips to zero your scope accurately and easily.",
                    matchProduct:'HS650R',
                    matchSeries:'NVMD,ZULUS,ZULUS-V2,ThermNight,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/QjAj8TbxK_E?si=ncOdbSCy8XZJLprh?enablejsapi=1&autoplay=1',
                    title:'QDF170 Flip-to-side Quick Detach Mount Designed For NVMD',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/nvmd-ht-poster.webp?v=1765248022',
                    id:'20',
                    type:'HT',
                    source:'yuotubo',
                    descrption:"Engineered at a 1.7″ optic height, the QDF170 is optimized for pairing the NVMD scope with red dot sights. This mount enables the NVMD's unique Flip-to-side features: flipping the device triggers either automatic recording or standby mode. It locks in solid and detaches instantly without losing zero, providing fast, tool-less setup.",
                    matchProduct:'QDF170,NVMD-C200',
                    matchSeries:'Mounts,NVMD',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/OKKqMSX0Fro?si=vioQdIJYdrXmHm2A?enablejsapi=1&autoplay=1',
                    title:'QDM150 Multi-Functional Quick Detach Mount Designed For DNT Hydra',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/qdm150-poster.png?v=1758328844',
                    id:'19',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'This video explains how to use QDM150 scope mount.<br/>The QDM150 quick release mount lets you detach and secure optic in seconds, whch empowers the Hydra series’s full capacity and versatility. It enables effortless switching between thermal clip-on, handheld monocular, and standalone scope operations. <br/> This versatile detach mount also works seamlessly with the ThermNight, ZULUS HD series, providing maximum versatility across your gear.',
                    matchProduct:'QDM150,QDS150',
                    matchSeries:'Mounts,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/ASEqua-WQ3g?si=TwbF0RkaRijyEJ7l?enablejsapi=1&autoplay=1',
                    title:'HOW TO Use the Product Comparison Feature | DNT Optics',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/b2e53872db5d469c95f369b00d593ae5.png?v=1757641711',
                    id:'18',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'Choosing the right product just got easier! DNT Optics has released the Product Comparison Feature in our online store. In this video, we’ll walk you through how to use it step by step.With this powerful tool, you can: <br/>1. Compare multiple products side by side<br/>2. See key differences at a glance<br/>3. Pick the product that best fits your needs',
                    matchProduct:'TNC225R,HS219,HS635R',
                    matchSeries:'NVMD,Hydra,HOUND,ThermNight,ZULUS,ZULUS-V2',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/m4f0rDfHwFE?si=XTTezbaGUULnbULu?enablejsapi=1&autoplay=1',
                    title:'How to Identify & Adjust the Zero and Ballistic Profiles on ZULUS HD',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/howto1.png?v=1752200675',
                    id:'17',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'In this video, we walk you through how to identify and adjust the Zero Profile and Ballistic Profile on the DNT ZULUS HD Day and Night Vision Scope.',
                    matchProduct:'ZHD520R-V2,ZHD520-V2,ZHD312R-V2',
                    matchSeries:'ZULUS',
                    matchModle:''
                },
                 {
                    iframeUrl:'https://www.youtube.com/embed/rCgc3AtvDTs?si=Pyj_sIAHriraq8vI?enablejsapi=1&autoplay=1',
                    title:'How to Use Your MacBook to Update DNT Optics Firmware and Transfer Videos',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/How_to_Use_Your_MacBook_to_Update_DNT_Optics_Firmware_and_Transfer_Videos.png?v=1751336009',
                    id:'16',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'In this step-by-step tutorial, learn how to update firmware on your DNT scopes using a MacBook, and how to transfer videos from the scope to your computer with ease. ',
                    matchProduct:'ZHD520R-V2,HS225R,TNC635R',
                    matchSeries:'NVMD,Hydra,HOUND,ThermNight,ZULUS,ZULUS-V2',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/v_5Dpq4JcdE?si=tZlyFBsJKTAGDkLS?enablejsapi=1&autoplay=1',
                    title:'How to Use Thermal Zoom Lock | DNT ThermNight TNC225R ',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/01603630-3884-48f8-A8EB-E5126C474BDB.png?v=1746697287',
                    id:'15',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'With Thermal Zoom Lock, the thermal image stays at base magnification for wide detection, while night vision zooms in for precise targeting. See more, aim better.<br> Update your TNC225R to the latest version (V20241211) to enable this new feature!',
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:'TNC225R'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/_uj6XNkM29M?si=ieqjPolUPLQPdeZ3?enablejsapi=1&autoplay=1',
                    title:'How to Zero the Hydra Thermal ',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/hydra_zero.png?v=1745718375',
                    id:'14',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'We walk you through the process of zeroing the Hydra thermal scope.',
                    matchProduct:'HS219,HS225R,HS635R',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/2a044a4f8fc1458c8c5c07dc05ed6157.mp4',
                    title:'How to Mount the HYDRA Scope with ADM AD-170-S ',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/ht-poster.jpg?v=1742173817',
                    id:'12',
                    type:'HT',
                    source:'local',
                    descrption:'In this video, we walk you through the quick and easy installation of the HYDRA with the ADM AD-170-S.',
                    matchProduct:'HS219,HS225R,ADM-Mount',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/2692f88c6600436eb7c0be49f869703d.mov',
                    title:'How To Adjust Your IR Torch (All Models)',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/howto.jpg?v=1734681469',
                    id:'1',
                    type:'HT',
                    source:'local',
                    descrption:'Here we show you how to adjust both the brightness and focus of the IR Torch ThermNight & ZULUs digital optics both allow the user to adjust the brightness of the IR, as well as the spill or throw of the beam.',
                    matchProduct:'ZHD520R-V2,TNC225R,TNC635R',
                    matchSeries:'ZULUS,ZULUS-V2,ThermNight',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/zd_kMtqjtN4?si=0e3LclstNonuORwb?enablejsapi=1&autoplay=1',
                    title:'HYDRA Clip-On Thermal: How to Zero',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/hydra-yt-bg.png?v=1741067323',
                    id:'11',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'Watch as we walk you through the process of zeroing the Hydra as a clip-on thermal mounted in front of your favorite low-powered variable optic (LPVO)',
                    matchProduct:'HS219,HS225R,HS635R',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/ihKyEWgpuKY?si=demNNc69WnwzsVEE?enablejsapi=1&autoplay=1',
                    title:'How To Zero Your DNT ThermNight',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_FORU.png?v=1735106203',
                    id:'4',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'',
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/sqDJ3_c4HY0?si=9tkfJr6J9uRCezwi?enablejsapi=1&autoplay=1',
                    title:'How to Zero the DNT Zulus Digital Day/Night Scope',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/70DE906C-E647-4dc3-B171-0EDFD2F693DB.png?v=1744247397',
                    id:'13',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'',
                    matchProduct:'ZHD312R,ZHD312R-V2,ZHD520R-V2',
                    matchSeries:'ZULUS',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/3EFplCrp6Q0?si=SbP1TSgEyIE1ld4e?enablejsapi=1&autoplay=1',
                    title:'Add Your Load Data To Your Optic',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_TWO.png?v=1735106203',
                    id:'2',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'To start using the Ballistic Calculator feature of the Thermnight and ZULUs, you must first enter your load data This can be done via the app or entered directly into the optic itself.',
                    matchProduct:'TNC225R,ZHD520R-V2,HS635R',
                    matchSeries:'ZULUS,ThermNight',
                    matchModle:''
                },{
                    iframeUrl:'https://www.youtube.com/embed/BOunT3EfnPQ?si=YfI7Lr8I_3j8UA82?enablejsapi=1&autoplay=1',
                    title:'How To Maximize Your Battery Charging',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_Bettery.png?v=1735183983',
                    id:'3',
                    type:'HT',
                    source:'yuotubo',
                    descrption:'The supplied charging cradle has several settings depending on how quickly you want your battery to charge.',
                    matchProduct:'ZHD312R-V2,TNC635R,HS635',
                    matchSeries:'NVMD,ZULUS-V2,HOUND,Hydra,ZULUS,ThermNight',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/29891589f4ec4280b2ed5b61e76d9902.mov',
                    title:'How To Update Firmware On The ThermNight',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_ThermNight2.png?v=1735282191',
                    id:'10',
                    type:'HT',
                    source:'local',
                    descrption:'In this tutorial you will learn how to draw schematic, do PCB layout, manufacture your board and programming.',
                    matchProduct:'TNC225R,TNC335R,ZHD520R-V2',
                    matchSeries:'ThermNight',
                    matchModle:''
                }
            ]
        },
        {
            name:'Spotlight on Products',
            type:'PR',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/D2ClBM2T2_8?si=QiSNOpiDWgRUcN6X?enablejsapi=1&autoplay=1',
                    title:'From Drills To Match Day. TheOne Prepares For The Season.',
                    poster: 'https://i.ytimg.com/vi/D2ClBM2T2_8/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAR39CAWAhqy-AifmXPzS72nkJ1iA',
                    id:'21',
                    type:'PR',
                    source:'yuotubo',
                    descrption:"TheOne built for serious distance shooters:<br/>\
                            ✔️ Massive 7–35X zoom range<br/>\
                            ✔️ Premium Japanese X-ED glass<br/>\
                            ✔️ Illuminated TOR reticle with zero stop<br/>\
                            ✔️ Rock-solid 34mm tube — recoil-proof, waterproof, field-ready",
                    matchProduct:'TheOne',
                    matchSeries:'TheOne',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/edd70fcda6a744bca6adb2b8aed54155.mp4',
                    title:'HYDRA 3-in-1 Thermal – Now Standard with the QDM150 Quick Detach Mount',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/QDM150-POSTER.webp?v=1772782526',
                    id:'20',
                    type:'PR',
                    source:'local',
                    descrption:'This video demonstrates the HYDRA 3-in-1 Multi-Functional Scope, now standard with the QDM150 quick detach mount. See how this pairing enables effortless transitions between handheld, clip-on, and standalone modes while maintaining fast attachment and a reliable return-to-zero.',
                    matchProduct:'HS325,HS635R,HS650R',
                    matchSeries:'Hydra,Mounts',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/ilEQoetwOXk?si=WOMHv1otUTKQR4r3?enablejsapi=1&autoplay=1',
                    title:"HOUND Ballistic Thermal Monocular Quick Unboxing | What's in the Box?",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/b68b288029e44d1da8a627bc3b6ebf6f.webp?v=1769567714',
                    id:'19',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'Unbox the HOUND — thermal vision and ballistic precision, ready to level up your hunt!',
                    matchProduct:'H315R,H325R,H635R',
                    matchSeries:'HOUND',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/DA1x7YJTGwI?si=SxGwKv4UZjzqSv9U?enablejsapi=1&autoplay=1',
                    title:"Unboxing the ZULUS 4K: What's in the Box? | DNT Optics",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/4c62f29b73a3431ca6a24ecbb6081aab.webp?v=1769567182',
                    id:'18',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'Unboxing ZULUS 4K — clarity, control, and an effortless setup that’s ready for the field right out of the box.',
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS-4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/ohauPjlm9FM?si=xTckj1MPCs5DuXry?enablejsapi=1&autoplay=1',
                    title:"ZULUS 4K: Command Every Yard With 4K Clarity | DNT Optics",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/7d739d25f7b0474596a07805a5115fa5.webp?v=1768875934',
                    id:'17',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'The new DNT ZULUS 4K Tube-Style Digital Day & Night Vision Scope marks the next step in digital optics.\
                    <br/>Designed to see beyond 4K and take control of every yard, it delivers clear, detailed imaging from daylight to moonlight. An \
                    integrated laser rangefinder with DNT Ballistic Engine provides confident control at any distance.<br/>\
                    Purpose-built and well-balanced, ZULUS 4K commands every yard with 4K clarity.',
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS-4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/AOGcAwZppx8?si=5UNyYzoJ1MKv1Odx?enablejsapi=1&autoplay=1',
                    title:"HOUND Usage Demo & Ballistic Test | DNT Optics",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/a946aaa5245d477ea9c326285e4b7595.webp?v=1766728329',
                    id:'16',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'This video provides a quick demo of the HOUND Ballistic Thermal Monocular. It shows how the laser rangefinder and ballistic calculator work in the field, with target ranges at 300, 400, and 500 yards.',
                    matchProduct:'H315R,H325R,H635R',
                    matchSeries:'HOUND',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/v5YdB6Tayg8?si=Mu3iGr8CYc-qGvtQ?enablejsapi=1&autoplay=1',
                    title:"NVMD-C200 Night Vision Multi-Purpose Device Overview",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/nvmd-overview-poster.webp?v=1765248296',
                    id:'15',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'Discover the versatility of the DNT NVMD-C200, the definitive 4-in-1 digital night vision solution combining Red Dot Magnifier, Standalone Scope, Clip-On, and Action Camera.',
                    matchProduct:'NVMD-C200,QDF170',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/GJpD_lSwhWQ?si=rig544iosyGwoCm1?enablejsapi=1&autoplay=1',
                    title:"HOUND Ballistic Thermal Monocular: Designed to Track, Perfected for Ballistics",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/NVMD-POSTER.webp?v=1764142353',
                    id:'13',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'The HOUND Ballistic Thermal Monocular is here! This compact, ergonomic handheld integrates thermal tracking, the powerful Laser Rangefinder, and the precision Ballistic Calculator. Featuring AI-enhanced Image Super Resolution and rugged durability, HOUND instantly computes the exact aiming solution you need for precise long-range hunting.',
                    matchProduct:'H315R,H325R,H635R',
                    matchSeries:'HOUND',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/TYmWqyROKhc?si=-RMTQXxBEqxD3D4E?enablejsapi=1&autoplay=1',
                    title:"NVMD, Your Ultimate All-in-One Digital Night Vision Solution",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/38eb380832b647c2a972235803a1167a.webp?v=1764143031',
                    id:'14',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'Meet the most versatile DNT NVMD-C200 Digital Night Vision Device.<br/>Red Dot Magnifier, Standalone Scope, Clip-On, Action Camera — four functions in one device, with four imaging modes: Full Color for daytime, and Black & White, Green Phosphor, and White Phosphor for nighttime. Engineered for precision, reliability, and adaptability, NVMD-C200 gives you the edge in every scenario.',
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
               {
                    url:'https://cdn.shopify.com/videos/c/o/v/374d46f3b9e7417a8287a4f835132a6a.mp4',
                    title:'Introducing The New 384 & 640 ThermNights!',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_THERMNIGHT.png?v=1735106974',
                    id:'7',
                    type:'PR',
                    source:'local',
                    descrption:'The newest additions to the ThermNight line have improved resolution, improved controls, and the new AutoWake feature! These are currently en route to our warehouse, and we expect to start fulfilling orders in the second half of December.',
                    matchProduct:'TNC335R,TNC635R,TNC225R',
                    matchSeries:'ThermNight',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/9b5912c237a949f590ef9ed054b7939e.mp4',
                    title:'Hydra: 3-in-1Capability',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/hydra.jpg?v=1734681468',
                    id:'5',
                    type:'PR',
                    source:'local',
                    descrption:'Our new Hydra easily transition from handheld to clip-on to standalone scope. No matter what you are after (or what is after you) the DNT Hydra brings the heat!',
                    matchProduct:'HS219,HS225R,HS635R',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/mdW8wvz9ry4?si=OXCrmAoisyc2dpzI?enablejsapi=1&autoplay=1',
                    title:"DNT's NEWEST 3-IN-1 THERMAL - The Hydra",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_HYDRA.png?v=1735283166',
                    id:'11',
                    type:'PR',
                    source:'yuotubo',
                    descrption:'This digital thermal scope can function as a handheld scanner, a stand-alone optic, or a clip-on in front of your LPVO or prismatic sight. Learn more and order yours today at www.dntoptics.com',
                    matchProduct:'HS219,HS225R,HS635R',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/IxhjTjTmyQg?si=BLn6oFeS8J6BabE2?enablejsapi=1&autoplay=1',
                    title:"Introducing The ONE 7-35x56 FFP from DNT Optics",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_LONG.png?v=1735283557',
                    id:'12',
                    type:'PR',
                    source:'yuotubo',
                    descrption:"We're proud to announce our first conventional optic:The ONE 7-35x56mm FFP. This 34mm scope is available in both MRAD and MOA reticles with Zero-Stop turrets, and offers a wide range of features for the discerning competitive long-range marksman.",
                    matchProduct:'TheOne',
                    matchSeries:'TheOne',
                    matchModle:''
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/72e55fcf82314cd6b547c7bcb232c08c.mp4',
                    title:'DNT ThermNight Multispectral Scope TNC225R',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_225R.png?v=1735107472',
                    id:'6',
                    type:'PR',
                    source:'local',
                    descrption:'The NEW ThermNight TNC225R is the most versatile digital scope on the market. It features a Sony STARVIS 2 sensor to see in the day or night. It also has a 256 thermal sensor for seeing heat. You can switch between the two with the touch of a button as well as have both with picture in picture. The ThermNight has a built-in laser range finder and onboard ballistic calculator. Range to target and it will calculate a ballistic solution then show you where to aim all in the blink of an eye. ',
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:'TNC225R'
                }
                ,{
                    url:'https://cdn.shopify.com/videos/c/o/v/53a825eee40a4cadb42b8891945bf9ec.mp4',
                    title:'DNT ZULUS HD 3-12x Digital Night Vision Scope',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_ZULUS.png?v=1735106752',
                    id:'8',
                    type:'PR',
                    source:'local',
                    descrption:'The long awaited ZULUS HD 3-12x is here. This scope uses the latest Sony STARVIS 2 sensor which performs excellent in day or night. The scope has a wider FOV than previous ZULUS models. The FOV is 7.97º x 4.49º. For day time use it is full color. Switch to night mode with the touch of a button and it switches to black and white for higher low light sensitivity combined with the ability to see Near Infrared (NIR). The ZULUS HD 3-12x has an onboard IR VCSEL illuminator, laser range finder and ballistic calculator. Use the VCSEL IR Illuminator to illuminate the dark. The laser range finder will measure your distance to target while the onboard ballistic calculator will calculate a ballistic solution and the aiming method you choose in the scope will show you where to aim.',
                    matchProduct:'ZHD312R,ZHD312R-V2,ZHD520R-V2',
                    matchSeries:'ZULUS-V2',
                    matchModle:'ZHD312R'
                }
            ]
        },
        {
            name:'Review Videos',
            type:'RV',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/x44pi2J5_VU?si=NMuc81nMa5LZC4SE?enablejsapi=1&autoplay=1',
                    title:"Can This Scope Really Make Long Range Shooting Easier?",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/f0148523d45d4c87b26d1cf26212665e.webp?v=1769509256',
                    id:'RV_8',
                    type:'RV',
                    source:'yuotubo',
                    descrption:"Check out DNT: https://us.dntoptics.com/texasplinking (Code 'texasplinking' gets you the best price currently available) A few months \
                    back, I made a video with the DNT Zulus V2 (HD) and talked about how likely that digital scope was to replace our optical glass scopes. Now, there \
                    is the new & improved Zulus 4K. Now featuring a 4K image and a 3-24 zoom range. It too has an LRF (laser range finder) and built in ballistic calculator \
                    so theoretically, you can range a target, and the scope tells you where to hold. So, can this optic make long range shooting easier? Oh yeah, and it's a \
                    digital night vision scope too. (All for well under $1k.) I featured it on my Brenton AR chambered in 6mm ARC and shoot at ranges from 100 yards all \
                    the way to 1,000 yards. Check out DNT here: https://us.dntoptics.com/texasplinking (Code 'texasplinking' gets you the best deal available)\
                    ",
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS-4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/issIDE9WopI?si=IWklDPd6lgQB9Fkl?enablejsapi=1&autoplay=1',
                    title:"DNT OPTICS ZULUS 4K DIGITAL SCOPE, I DIDN'T EXPECT IT TO BE THIS GOOD",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/85ca52850f7546d5a18f0e0f88b6138e.webp?v=1769508986',
                    id:'RV_7',
                    type:'RV',
                    source:'yuotubo',
                    descrption:"Today we take a look at the Zulus 4k digital scope from DNT. With a traditional glass optic appearance, eye relief, and feel this digital \
                    scope makes me reconsider the actual use and future of digital scopes. <br/>\
                    For an all purpose set up with a lot of features this will be hard to beat for $850. Laser range finder, 4k viewing resolution, recording, day or \
                    night use, you get a lot for the price point. <br/>\
                    I have no affiliations with DNT, they didn't pay me for this review, there is no affiliate links. This is my honest review of this optic.\
                    ",
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS-4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/P1YfphuJtDA?si=Nk7NTPwG7oupEa4a?enablejsapi=1&autoplay=1',
                    title:"Hear It from Pro Hunters & Shooters! Real Talk on the DNT ZULUS",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/Hear_It_from_Pro_Hunters_Shooters_Real_Talk_on_the_DNT_ZULUS.png?v=1750497222',
                    id:'RV_5',
                    type:'RV',
                    source:'yuotubo',
                    descrption:"Discover what pro hunters and expert marksmen are saying about the DNT ZULUS Day/Night Scope. Real feedback. Real performance. Find out why they trust it!",
                    matchProduct:'ZHD312R,ZHD312R-V2,ZHD520R-V2',
                    matchSeries:'ZULUS',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/KAfhqafKWNM?si=OjmRh4nfrndZ3U8N?enablejsapi=1&autoplay=1',
                    title:"Day and Night Thermal (that's under a grand!) DNT ThermNight TNC225R",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_thermnightprice.png?v=1735547029',
                    id:'RV_2',
                    type:'RV',
                    source:'yuotubo',
                    descrption:"DNT's TNC225R Thermal optic with night vision and ballistic calculator will get the job done for you for $989 with code TopShot10",
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:'TNC225R'
                }
            ]
        },
        {
            name:'Event Highlights',
            type:'PT',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/-E2kk_ISqI4?si=Pn4OhtWXwkorVIcL?enablejsapi=1&autoplay=1',
                    title:'DNT Mission Continues — Next Stop: NRAAM 2026',
                    poster: 'https://i.ytimg.com/vi/-E2kk_ISqI4/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLApkbkfKIqpK_Itx3kZ4C6ohPfowA',
                    id:'PT_2',
                    type:'PT',
                    source:'yuotubo',
                    descrption:"Heading to NRAAM 2026? Come see us at Booth 529!<br/>\
                    Get hands-on with the DNT lineup, chat with our team and stick around for a few surprises!<br/>\
                    Discover more on our official website: <a href='https://us.dntoptics.com/'>https://us.dntoptics.com/</a> <br/>\
                    Connect with us across social platforms:<br/>\
                    Facebook:   / dntoptics  <br/>\
                    Instagram:   / dnt_optics  ",
                    matchProduct:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/vqlKt08lWc0?si=MqU74Qf9WLJhKm8R?enablejsapi=1&autoplay=1',
                    title:'On The Range With Demolition Ranch',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_PT_RANGE.png?v=1735608632',
                    id:'PT_1',
                    type:'PT',
                    source:'yuotubo',
                    descrption:'We had a fantastic time out at the Demo Ranch range day.Met a ton of cool people and got to show off the full line of DNT Optics.',
                    matchProduct:'TNC225R,ZHD520R-V2,HS635R'
                },
                {
                    url:'https://cdn.shopify.com/videos/c/o/v/34f750f1f1af43df855ccd99c1e4c5c1.mp4',
                    title:'Fouled Bore - Silent Night PRS Match 2024',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/SilentNight.jpg?v=1735281097',
                    id:'9',
                    type:'PT',
                    source:'local',
                    descrption:'The one thing standing between you and the perfect shot is precision that thrives beyond the limits.',
                    matchProduct:'TheOne'
                }
            ]
        },
        {
            name:'Comparison Videos',
            type:'CV',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/hCyG2ZamggA?si=_HTOb3TRG1-mIkP2?enablejsapi=1&autoplay=1',
                    title:"How to Choose the QDS150 or QDM150 Mount | DNT Optics",
                    poster: 'https://i.ytimg.com/vi/hCyG2ZamggA/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCDSVepFaGI8yh0tmaZjhgtaQL2XA',
                    id:'CV09',
                    type:'CV',
                    source:'yuotubo',
                    descrption:'Elevate your experience with the DNT Quick Detach system — QDS150 and QDM150.<br/>\
                    Both aircraft-grade aluminum mounts provide a 1.5" optical centerline with a secure, tool-less automatic locking mechanism.<br/>\
                    ✅ QDS150: Ultra-lightweight (2.93 oz) and streamlined for maximum portability. <br/>\
                    ✅ QDM150: Multi-functional with dual-sided flexibility for rifle or handheld use.<br/>\
                    Compatibility: Fits ThermNight, ZULUS HD, and HYDRA series. Note: Not compatible with early TNC225R models featuring a square mounting base.',
                    matchProduct:'QDS150,QDM150',
                    matchSeries:'Mounts',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/xrxoK-n9Pok?si=3QtRHeamYq6tPg77?enablejsapi=1&autoplay=1',
                    title:'ZULUS V2 vs ZULUS 4K vs NVMD-C200 | 50-1000 Yard Night Vision Comparison',
                    poster:'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/yourub-poster.webp?v=1780361497',
                    id:'CV08',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"Trying to choose between the ZULUS V2 vs ZULUS 4K vs NVMD-C200?<br/>\
                                We put all three to the test from 50 to 1000+ yards across a full range of real-world lighting conditions.<br/>\
                                In this episode of DNT Academy, we run a side-by-side comparison of our digital night vision lineup to show exactly how each optic performs from close range all the way out to extreme distance — in daylight, low light, and complete darkness.<br/>\
                                The goal here isn’t to pick a winner. It’s to show what each optic is built for, so you can choose what best fits your setup, shooting style, budget, and target.<br/>\
                                Chapters<br/>\
                                00:00 Intro<br/>\
                                00:29 Day Mode 50 Yards<br/>\
                                01:34 Day Mode 100 Yards<br/>\
                                02:20 Day Mode 300 Yards<br/>\
                                03:57 Day Mode 600 Yards<br/>\
                                04:35 Day Mode 1000 Yards<br/>\
                                05:25 Low Light Day Mode 50 Yards<br/>\
                                06:11 Low Light IR Off 50 Yards<br/>\
                                06:28 Low Light IR On 50 Yards<br/>\
                                07:11 No Light IR On 100 Yards<br/>\
                                07:30 No Light IR On 300 Yards<br/>\
                                08:28 No Light IR On 1000 Yards<br/>\
                                09:52 Deer at 1200 Yards<br/>\
                                10:14 Outro",
                    matchProduct:'ZULUS 4K,NVMD-C200,ZHD520-V2',
                    matchSeries:'ZULUS-V2,ZULUS-4K,NVMD',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/7hCPihVGsaM?si=7Byk5HmAPWDsg7eq?enablejsapi=1&autoplay=1',
                    title:'256 VS 640 Thermal Comparison! DNT Hydra HS225 HS635',
                    poster: 'https://i.ytimg.com/vi/7hCPihVGsaM/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBW4adJYABQYLKhBHcf83VYmfCnSw',
                    id:'CV07',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"I test the DNT Hydra HS225 and HS635 to show you the difference between lower and higher resolution thermals. #thermal #dnt #scope #nightvision <br/>\
                        Below may be affiliate links earning me a small commission but not costing you any extra.<br/>\
                        Coupon Code TKOUTDOORS <br/>\
                        DNT Hydra HS225: <a href='https://us.dntoptics.com/gqifbb'>https://us.dntoptics.com/gqifbb</a> <br/>\
                        DNT Hydra HS325 (Not shown): <a href='https://us.dntoptics.com/zrg5tp'>https://us.dntoptics.com/zrg5tp</a> <br/>\
                        DNT Hydra HS635: <a href='https://us.dntoptics.com/6gsjtr'>https://us.dntoptics.com/6gsjtr</a>",
                    matchProduct:'HS225,HS635',
                    matchSeries:'Hydra',
                    matchModle:'HS225,HS635'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/2oW92N6OSq4?si=w-lfIp39DSdMLM0W?enablejsapi=1&autoplay=1',
                    title:'How to Use the DNT ThermNight TNC225R/335R/635R | Feature Walkthrough',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/991276f77cf8407eb2895bdd398a9ad1.webp?v=1767592493',
                    id:'CV00',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"In this video, I give you a full walkthrough and user guide for the DNT Optics ThermNight TNC225R, \
                    TNC335R and TNC635R – powerful day, night, and thermal scopes packed with features.<br/>Whether you just picked up this scope or you're \
                    trying to figure out some of the more advanced functions, this video has you covered. I go over everything from the basic setup, zeroing, \
                    and ballistic calculator, to range finding, recording, and in-scope display settings.",
                    matchProduct:'TNC635R,TNC335R,TNC225R',
                    matchSeries:'ThermNight',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/z19-FzVWb-0?si=GInntWfG8lONbSeP?enablejsapi=1&autoplay=1',
                    title:'Best Thermal & Night Vision Guide of 2025 - DNT Optics ThermNight Overview',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/d3a4d26941ff4975a701903ca273faef.webp?v=1767592835',
                    id:'CV01',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"In this video, we dive into the DNT Optics ThermNight product line — a series of advanced multispectral rifle scopes \
                    that combine thermal imaging with digital night vision to deliver a true all‑in‑one optics solution for hunting, predator control, \
                    and low‑light shooting.<br/>I walk through the full ThermNight lineup, explain how thermal and digital night vision work together, \
                    and help you understand which model makes the most sense for your hunting style and terrain.",
                    matchProduct:'TNC635R,TNC335R,TNC225R',
                    matchSeries:'ThermNight',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/jmccG_w-Y_o?si=sofsccNYeg8rWEEC?enablejsapi=1&autoplay=1',
                    title:'DNT Optics QDM150 Red Dot Adapter Mount',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/34d57197f9ae4a0da4502f0b1a90f886.webp?v=1767593413',
                    id:'CV02',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"DNT Optics has really made a name for themselves in the thermal optic market with the Hydra and ThermNight models. \
                    Now they are even better and more useable with the addition of the new QDM-150 mounts. It allows you to quickly detach the thermal \
                    and also allows you to mount an offset red dot optic to pair with the thermal. ",
                    matchProduct:'HS335,HS225,QDM150',
                    matchSeries:'Hydra,Mounts',
                    matchModle:'HS335,HS225,QDM150,QDM150-RMR'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/iGljACdClFI?si=Lu1eSpvIhx2jfAc7?enablejsapi=1&autoplay=1',
                    title:'Leupold MK5 HD vs. DNT The One',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/2526906b3c664a3bbe278eb081741488.webp?v=1767593824',
                    id:'CV03',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"",
                    matchProduct:'TheOne',
                    matchSeries:'TheOne',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/BD0sEUo2TRo?si=iBF2VtiGGnWL_MKk?enablejsapi=1&autoplay=1',
                    title:'DNT Optics Zulus HD Night Vision Scope V1 vs V2 - Full Comparison & Review',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/a8d04e51db904f7d96604f79abe689c7.webp?v=1767594125',
                    id:'CV04',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"I put the DNT Optics Zulus HD v1 and the new v2 head-to-head in this full comparison and field test. In this\
                     video, I break down the key upgrades of the Zulus HD v2, explain how it works, and put it to the test in real-world hunting scenarios. \
                     You’ll see actual shooting and hunting footage using the Zulus HD v2 in action. Whether you're looking to upgrade or buy your first digital\
                      night vision optic, this video will help you understand the performance difference and improvements made by DNT Optics.",
                    matchProduct:'ZHD520R-V2',
                    matchSeries:'ZULUS,ZULUS-V2',
                    matchModle:'ZHD520R,ZHD520R-V2'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/RLPViPo7fms?si=Hy_NNsyzOdnETPO8?enablejsapi=1&autoplay=1',
                    title:"Picking The Right Thermal Optic: Hydra v. ThermNight",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/DA490B48-DE86-4a84-B3E0-0B08A6C84D60.png?v=1743407798',
                    id:'CV05',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"There are a lot of options to pick from when considering digital thermal optics for hunting or target shooting. We compare the Hydra Therma. vs. the ThermNight Multispectral scope to help you pick the best option for your needs.",
                    matchProduct:"HS225R,TNC225R,HS635R,TNC635R",
                    matchSeries:'ThermNight,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/r9Ew6hPJsVk?si=tvdonyXkPsLIlfU3?enablejsapi=1&autoplay=1',
                    title:"DNT Thermnight TNC225R, TNC335R & TNC635R daylight comparisons",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/HT_dntOptics.jpg?v=1735611161',
                    id:'CV06',
                    type:'CV',
                    source:'yuotubo',
                    descrption:"(Recorded 8th November) Andrew Dickinson DNT’s new UK Sales Representative joined me in our front garden for a three-way ThermNight scope test.  He, Ryan and Estella from DNT brought with them the first TNC335R and TNC635R scopes, to give me first chance to compare them.",
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:''
                }
            ]
        },
        {
            name:'Performance in Field',
            type:'PF',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/eJGdpjrRipM?si=NGv72Gw2zHienMr0?enablejsapi=1&autoplay=1',
                    title:'Budget Day/Night Scope: DNT Zulus V2 HD 5-20x Day Night Scope',
                    poster: 'https://i.ytimg.com/vi/eJGdpjrRipM/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDV7v6GdIjjhGBE9PoTHKAEsNhR7Q',
                    id:'PF14',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"Subscribe to <a href='https://www.youtube.com/@DNTOptics'>‪@DNTOptics‬!</a>",
                    matchProduct:'ZHD520R-V2',
                    matchSeries:'ZULUS-V2',
                    matchModle:'ZHD520R-V2'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/7h3y1Y3DeZM?si=fU8soQigDnug3ziW?enablejsapi=1&autoplay=1',
                    title:'NVG Shooting Made Affordable | DNT Optics NVMD C-200',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/nvmd-200-poster.webp?v=1781159219',
                    id:'PF13',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"In today’s video we check out the all new NVMD C-200 from the team over at <a href='https://www.youtube.com/@DNTOptics'>‪@DNTOptics‬!</a>  This is perfect timing \
                    for the summer months ahead as we like to hit the range at night for night vision fun!  If you’ve been looking for a way to get into the night\
                     vision game without breaking the bank, then this is a video for you!  Let us know what you think about this new offering from the DNT Optics team down below, hey oh!",
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/dJW7Wl-jbD4?si=y8f-4YKJtIWAJMYG?enablejsapi=1&autoplay=1',
                    title:'Is this the future? DNT Zulus 4k',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/zulus-4kposter.webp?v=1781158914',
                    id:'PF12',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"DNT Zulus and the Garmin C2 with Tactix 8",
                    matchProduct:'ZULUS 4K',
                    matchSeries:'ZULUS-4K',
                    matchModle:'ZULUS 4K'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/yJC2Ei0yuSU?si=lv-sbnHG2YUla4yK?enablejsapi=1&autoplay=1',
                    title:'DNT - THE ONE 7-35x56: Worth it?',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/theone-poster.webp?v=1781158649',
                    id:'PF11',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"My honest review of DNT Optics - The ONE 7-35 x 56 34mm FFP rifle scope. <br/>\
                                I packed in as much information as I could, let me know what you think.",
                    matchProduct:'TheOne',
                    matchSeries:'TheOne',
                    matchModle:'TheOne'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/UKpFxCN-dVE?si=lBaym23cwEuAbtKj?enablejsapi=1&autoplay=1',
                    title:'Why Carry More? Simplify Your Hunt with the HYDRA & QDM150',
                    poster: 'https://i.ytimg.com/vi/UKpFxCN-dVE/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDvOqsnce2Mtol9dv-4lCXNlljaWQ',
                    id:'PF10',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"With the HYDRA and QDM150, you no longer need multiple devices to meet your in-field requirements. One system handles handheld detection, standalone aiming, and \
                    clip-on capability—all with zero recalibration.<br/>\
                    Watch the video to see how the HYDRA system empowers you in real-world conditions.",
                    matchProduct:'HS219,HS335R,HS650R',
                    matchSeries:'Hydra,Mounts',
                    matchModle:'Hydra,Mounts'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/_k0DwNPVdhc?si=KL80M7KfMu0T630L?enablejsapi=1&autoplay=1',
                    title:"Non Stop Hog Hunting Action with the NEW DNT Optics HYDRA LRF",
                    poster: 'https://i.ytimg.com/vi/_k0DwNPVdhc/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBQ_qjIhuKuQLExeBs0xg0QLY3VBg',
                    id:'PF09',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"The brand new DNT Optics HYDRA LRF officially launched today, and I got the chance to put it to the test in the field. This is the HS335R model, featuring a 384 resolution thermal sensor.<br/><br/>\
                            This video is action packed with coyotes running around, pigs everywhere, and nonstop thermal action. I dropped three pigs on camera (and several more off camera) while getting incredible close-up thermal footage using the HYDRA.<br/><br/>\
                            I also tested the QD mount to see if it would hold zero after being removed and reattached, and it passed with flying colors.<br/><br/>\
                            If you’ve been curious about the new HYDRA LRF thermal lineup from DNT Optics, this video shows exactly what it can do in real hunting conditions.<br/><br/>\
                            Stay tuned for the FULL review and breakdown of the optic and its features!<br/><br/>\
                            0:00 - Intro <br/>\
                            1:40 - Starting thermal recording of hogs, coyotes, deer, cows <br/>\
                            4:27 - Big Boar 1 <br/>\
                            7:35 - Big Boar 2 <br/>\
                            9:31 - QD Mount overview <br/>\
                            13:00 - Footage of HUGE hog <br/>\
                            14:15 - Big Boar 3 <br/>\
                            16:03 - Analysis of the shot <br/>\
                            17:49 - Outro <br/>\
                            19:10 - Bucks fighting <br/><br/>\
                            DNT Optics HYDRA LRF Version - <a href='https://amzn.to/4ovWNH4'>https://amzn.to/4ovWNH4 </a>",
                    matchProduct:'HS335R',
                    matchSeries:'Hydra',
                    matchModle:'HS335R'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/MO2o_g2ZZpY?si=2YVHK_gpuXOgaNrd?enablejsapi=1&autoplay=1',
                    title:"The Cheapest Thermal Optic That's Actually Good!",
                    poster: 'https://i.ytimg.com/vi/MO2o_g2ZZpY/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCxRMlB50ZR3Y7a5872dyBHY_HR5w',
                    id:'PF08',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"Check out the HS219 here: https://us.dntoptics.com/ujhK3z (Use code 'texasplinking' to get the price as low as possible) <br/>\
                                Thermal optics have always been out of reach for many. Even 5 years ago a thermal optic b/w $3-5k was considered budget friendly relatively speaking. \
                                But in the last couple years, DNT has been cranking out optics that seem too good to be true but so far, they just work. I've talked about the DNT \
                                Hydra before, but now there's a new offering, the Hydra HS219. (The most affordable one yet) The Hydra is a 3-in-1 thermal optic. A dedicated thermal \
                                scope, thermal clip-on (for LPVOs and prism optics) as well as a monocular. Watch this video to see if the HS219 has the specs for you or if another \
                                offering better suits your needs. Thanks for watching! <br/>\
                                Applicable inks: (Use code 'texasplinking' for the cheapest prices) <br/>\
                                <a href='https://us.dntoptics.com/ujhK3z'>DNT: https://us.dntoptics.com/ujhK3z</a> <br/>\
                                <a href='https://www.grayboe.com/?aff=2'>Grayboe: https://www.grayboe.com/?aff=2</a> <br/>\
                                <a href='https://bit.ly/3YaY6zw'>Arken: https://bit.ly/3YaY6zw</a> ",
                    matchProduct:'HS219',
                    matchSeries:'Hydra',
                    matchModle:'HS219'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/n3Bhk4zOtzY?si=5geYVmuKz_AwYzVq?enablejsapi=1&autoplay=1',
                    title:'This does it ALL! DNT TNC635R',
                    poster: 'https://i.ytimg.com/vi/n3Bhk4zOtzY/hqdefault.jpg?sqp=-oaymwEnCOADEI4CSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLB3jkm_a2CTNNezflkKRHNRF4zXXQ',
                    id:'PF07',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"This is a long term evaluation of the DNT 635R.",
                    matchProduct:'TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:'TNC635R'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/Qavcq9cgRfc?si=F-ocLWhIYwV-3Nx7?enablejsapi=1&autoplay=1',
                    title:'This Turns EVERYTHING Into Night Vision For Under $600',
                    poster: 'https://i.ytimg.com/vi/Qavcq9cgRfc/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLB-A884YSeLBdKB8MpjP0NsWU3lOw',
                    id:'PF06',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"DNT NVMD C200: https://us.dntoptics.com/texasplinking (Code 'texasplinking' saves as much $ as possible)<br/>\
                    In this video, I review the new NVMD C200 from DNT. It operates as a compact digital day & night vision scope with 1-6x magnification, a digital \
                    magnifier turning your red dots & holographic optics into night vision devices, (also works as a digital magnifier during the day) as well as a \
                    clip-on durning your day scopes into digital night vision optics. It does all of that for just under $600. (When using code 'texasplinking' at checkout)\
                     Check it out here: https://us.dntoptics.com/texasplinking From my experience, this optic works great at night but like any digital night vision device, \
                     it really comes alive with IR (inferred) light. If you don't have some IR light already, I highly suggest getting some to use along side the NVMD. DNT \
                     just started offering some as well as a swivel mount so you can go back to your red dot, holographic, or day optic setup quick & easily. \
                     (DNT offers the NVMD, IR light and swivel mount as a bundle as well) <br/>\
                    Link to the Arken for the EP8 1-8X28 as shown in this video when in clip-on mode, use code 'texasplinking' for the biggest savings available: https://bit.ly/3Y0B5kz <br/>\
                    Link to checkout EOTech holographic optics: https://alnk.to/6TCL2Bq ",
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/W5eb4mvuL_o?si=EIwtKX_4JQzDkjJx?enablejsapi=1&autoplay=1',
                    title:'DNT Optics NVMD - A Multi Capable Night Vision Device You Can Afford',
                    poster: 'https://i.ytimg.com/vi/W5eb4mvuL_o/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBNan8C4EhXc5VU_OeNFBgfZXUwog',
                    id:'PF05',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"A comprehensive overview of the DNT Optics NVMD. In this video we'll go over the features and capabilities of the NVMD and test it \
                    out on the range. The NVMD is a multi-use night vision device that's capable of working as a standalone optic day or night, a magnifier behind \
                    a red dot sight day or night, a clip on on night vision device in front of a scope, or as a night vision capable action camera. Grab your own from DNT's \
                    website and use code SAVE10 for 10% off. ",
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/MbxhpCctkMc?si=vWZjHQaa8ZmUeL0w?enablejsapi=1&autoplay=1',
                    title:'THE BEST DAY/NIGHT/THERMAL SCOPE FOR THE MONEY? DNT 335R ThermNight',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/35be3079390546df8f8c73a7e72bb066.webp?v=1767595439',
                    id:'PF00',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"",
                    matchProduct:'TNC335R',
                    matchSeries:'ThermNight',
                    matchModle:'TNC335R'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/_s3y1BbJtQQ?si=4iNHlLNKxBU0NYFh?enablejsapi=1&autoplay=1',
                    title:'Affordable Thermal That Actually Works! DNT HS219',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/a8a700cdc78b4d0c8aa6cee5dc41e30e.webp?v=1767595731',
                    id:'PF01',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"I test a new budget thermal scope from DNT, the HS219.<br/>Links below may or may not be affiliate links earning me a small commission if used. Thanks!<br/>\
                    HS219 on Amazon: <a href='https://amzn.to/47oHkSf'>https://amzn.to/47oHkSf</a><br/>\
                    QDM Mount on Amazon: <a href='https://amzn.to/3KIkSfc'>https://amzn.to/3KIkSfc</a><br/>\
                    HS219 factory direct: <a href='https://us.dntoptics.com/products/hs219-hydra-256x192-19mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular'>https://us.dntoptics.com/products/hs219-hydra-256x192-19mm-multi-function-thermal-scope-standalone-scope-clip-on-handheld-monocular/a>",
                    matchProduct:'HS219,QDM150',
                    matchSeries:'Hydra,Mounts',
                    matchModle:'HS219,QDM150'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/fubJ6RcKZe4?si=lPkWyjucr-KRZQ_s?enablejsapi=1&autoplay=1',
                    title:'Is This Budget Night Vision Actually Good? DNT OPTICS ZULUS HD V2 Review',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/db1776a7fe9742fdbc5c5d9b462d623b.webp?v=1767596680',
                    id:'PF02',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"In this video, I review the DNT OPTICS ZULUS HD V2 3-12X Digital Day and Night Vision Scope (ZHD312R-V2) \
                     a feature-packed optic that includes a laser rangefinder, ballistic calculator, IR illuminator, and built-in 1080p video recording.",
                    matchProduct:'ZHD312R-V2',
                    matchSeries:'ZULUS-V2',
                    matchModle:'ZHD312R-V2'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/in1ZcFstfWg?si=2uF0IDfSLWjo9Zo7?enablejsapi=1&autoplay=1',
                    title:'This optic does EVERYTHING! Magnifier, NIGHT VISION, Action Camera... DNT NVMD',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/42d086dd68c64bcca40abe6fdd65dd03.webp?v=1767597077',
                    id:'PF03',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"NVMD is different than anything else on the market.  Not only is it a standalone optic capable of night vision, but you can \
                    use it in conjunction with your existing red dot or holographic sight as a 1-6x magnifier, or as an action camera, or as a clip on night \
                    ision device for your LPVO.  ",
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/b2GvM5Bcy8o?si=z5Gc7HDnCj3bah_J?enablejsapi=1&autoplay=1',
                    title:'DNT “The One” Scope Review — Is It Actually "The" Budget King?',
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/d436bbf584af4c779135309b224e8958.webp?v=1767597735',
                    id:'PF04',
                    type:'PF',
                    source:'yuotubo',
                    descrption:"is trying to make a name for themselves in the long-range world, and 'The One' is their first big swing — packed \
                    with features, priced under $800, and aimed squarely at the budget PRS crowd.<br/>\
                    I’ve been running it on my RimX and took it out for a proper test. This video’s got my honest thoughts — what works, what doesn’t,\
                     and whether this scope actually lives up to the hype.<br/>\
                     DNT did send me the scope, but they didn’t pay me, nor tell me what to say. What you’re hearing is exactly what I think after putting some rounds downrange.\
                    ",
                    matchProduct:'TheOne',
                    matchSeries:'TheOne',
                    matchModle:''
                },
            ]
        },
        {
            name:'DNT Community',
            type:'Community',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/ogPSXI3O_Ws?si=QCPtbkrAcudo4igb?enablejsapi=1&autoplay=1',
                    title:"DNT ProCare From Order to After Sales, We've Got You Covered",
                    poster: 'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/575974fe31684d72a7b79a571d2620e0.webp?v=1780363530',
                    id:'Community02',
                    type:'Community',
                    source:'yuotubo',
                    descrption:"DNT ProCare is a complete support system designed to take you from first purchase to confident performance and full capability in the field.<br/>\
                                Three specialized departments work together to support you at every stage:<br/>\
                                Fulfillment & Shipping Department<br/>\
                                Behind every order is a dedicated team focused on accuracy and speed. Your order is verified, carefully picked, and precisely packed before being shipped via second-day air. We're committed to getting your gear to you quickly and reliably.<br/>\
                                Customer Service Team<br/>\
                                Real people answer your calls and emails—trained specialists who understand thermal imaging, night vision, shooting applications, and field performance. Whether you need pre-sales advice, technical support, or troubleshooting, we're here to help you use your gear with confidence.<br/>\
                                RMA & Repair Department<br/>\
                                Behind every warranty claim is a dedicated team and a proven process focused on restoring performance, not just fixing issues. From inspection to environmental testing, recoil testing, and final verification, every repair is handled with precision. <br/>\
                                DNT ProCare follows you from your first zeroing to your most demanding hunts. Built by experts who live for the field, we deliver the steady hand and technical mastery needed for absolute confidence in real-world conditions.<br/>\
                                Learn more about our support system: https://us.dntoptics.com/pages/dnt-pr... <br/>\
                                Connect with us across social platforms:<br/>\
                                Facebook:   <a href='https://www.facebook.com/DNTOptics' target='_blank'>/ dntoptics  </a> <br/>\
                                Instagram:  <a href='https://www.instagram.com/dnt_optics/' target='_blank'> / dnt_optics </a> ",
                    matchProduct:'',
                    matchSeries:'',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/radK25croBY?si=w7Q9VVWutqG36MmN?enablejsapi=1&autoplay=1',
                    title:'Passing Down the Passion for Hunting | DNT Optics User Story',
                    poster: 'https://i.ytimg.com/vi/radK25croBY/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDUpwutAJxnxFxbMMUQyAClrTmpfg',
                    id:'Community01',
                    type:'Community',
                    source:'yuotubo',
                    descrption:"Hunting isn't just about the gear—it's about the moments shared with the people you love. Family hunting traditions bring generations together, \
                    creating memories that last far beyond the season. At DNT Optics, we believe the role of technology is to make those moments more accessible and precise. <br/>\
                    In this volume of user stories, we look at how generations—from grandfathers and granddaughters to fathers and sons—hunt together with DNT optics to stay \
                    connected and share the same vision in the field. <br/>\
                    Have a hunting story to share? We'd love to hear from you. Send us a DM or tag @DNTOptics on social media. <br/>\
                    <a href='/hashtag/dntoptics'>#dntoptics</a> <a href='/hashtag/dntcommunity'>#dntcommunity</a><br/>\
                    Discover more on our official website: <a href='https://us.dntoptics.com/'>https://us.dntoptics.com/ </a>",
                    matchProduct:'ZHD520-V2,ZHD312-V2,ZULUS 4K',
                    matchSeries:'ZULUS-4K,ZULUS-V2',
                    matchModle:'ZULUS 4K,ZULUS-V2'
                },
            ]
        },
        {
            name:'DNT Academy',
            type:'Academy',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/i2LTRiZpjQA?si=Ngv_hOkXZq_oB95K?enablejsapi=1&autoplay=1',
                    title:"Hound Thermal Monocular Comparison | Choosing the Right Model",
                    poster:'https://i.ytimg.com/vi/i2LTRiZpjQA/hq720_custom_1.jpg?sqp=CIT4gdMG-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBthQmGAf7fs5WDDAElu5kvuXav3w',
                    id:'Academy07',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Trying to decide which Hound Thermal Monocular is right for you?<br/>\
                        In this episode of DNT Academy, we're comparing the Hound thermal monocular lineup to help you understand the differences between each model \
                        and choose the one that best fits your hunting style and budget.<br/>\
                        Whether you're scanning for hogs, locating coyotes, recovering game, or simply looking for the best thermal optics for your needs, understanding\
                        the strengths of each Hound model will help you make a more informed decision.",
                    matchProduct:'H315R,H325R,H635R',
                    matchSeries:'HOUND',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/EgYiHd08iaE?si=buz_lXf7O9buTbFU?enablejsapi=1&autoplay=1',
                    title:"Comparing the Zulus HD V2 3-12 and 5-20: Which One Should You Choose?",
                    poster:'https://i.ytimg.com/vi/EgYiHd08iaE/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAYhXACb8BpQmetxzglTimYum94nA',
                    id:'Academy06',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"One of the most common questions we hear is:<br/>\
                        'Should I get the Zulus HD V2 3-12 or the 5-20?'<br/>\
                        The answer depends on where you hunt and what type of shots you typically take.<br/>\
                        In this episode of DNT Academy, we're comparing both Zulus HD V2 models side by side and explaining the real-world differences—not just the specifications.<br/>\
                        We'll cover magnification, field of view, target acquisition, hunting scenarios, and who each optic is designed for so you can confidently choose the \
                        right digital day and night vision scope.<br/>\
                        Have questions? Drop them in the comments below.",
                    matchProduct:'ZHD520-V2,ZHD312-V2',
                    matchSeries:'ZULUS-V2',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/MCFYmacuUkE?si=cXhhtyqOTXNXinDp?enablejsapi=1&autoplay=1',
                    title:"Which HYDRA Thermal Is Right for You? Complete Buyer's Guide",
                    poster:'https://i.ytimg.com/vi/MCFYmacuUkE/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLDPc-rSn9KJntu1QsB-5RPycuAAUA',
                    id:'Academy05',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Trying to decide which HYDRA thermal optic is right for you?<br/>\
                        In this episode of DNT Academy, we're comparing the entire HYDRA thermal lineup and breaking down the key differences between each model so \
                        you can choose the best thermal scope for your hunting style, terrain, and shooting distances.<br/>\
                        Not every thermal optic is built for the same application. Some hunters prioritize field of view and quick target acquisition, while others need\
                        magnification and long-range performance. We'll help you understand where each HYDRA model excels and who it's best suited for.",
                    matchProduct:'HS225R,HS335R,HS650R',
                    matchSeries:'Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/nH68BHwFGiQ?si=RaMPQllqiM0mBMHo?enablejsapi=1&autoplay=1',
                    title:'ThermNight Thermal Comparison: Choosing the Right Model',
                    poster:'https://i.ytimg.com/vi/nH68BHwFGiQ/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLAzpNu1c_sBmU22di6LsuyNftMhDg',
                    id:'Academy04',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Thinking about buying a ThermNight thermal scope but not sure which model is right for you?<br/>\
                        You're not alone.<br/>\
                        One of the most common questions we hear is: 'What's the difference between the ThermNight models, and which one should I choose?'<br/>\
                        In this DNT Academy video, we're walking through the complete ThermNight thermal lineup and explaining the real-world advantages of each optic.<br/>\
                        Instead of focusing only on specifications, we'll discuss who each model was designed for, what hunting situations they excel in, and how to choose the best <br/>\
                        thermal optic for your specific needs.",
                    matchProduct:'TNC225R,TNC335R,TNC635R',
                    matchSeries:'ThermNight',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/lxHMlrot3zQ?si=WtQ9zd79l3Bitrea?enablejsapi=1&autoplay=1',
                    title:'ThermNight vs Hydra: Which Thermal Scope Should You Buy?',
                    poster:'https://i.ytimg.com/vi/lxHMlrot3zQ/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLBamx3PBppZGQeiB35lhEova98q7A',
                    id:'Academy03',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Trying to decide between the DNT ThermNight and DNT Hydra thermal optics?<br/>\
                        In this episode of DNT Academy, we're breaking down the differences between two of our most popular thermal scopes and helping you determine which one best \
                        fits your hunting style and shooting needs.<br/>\
                        Both optics deliver powerful thermal imaging capabilities, but they were designed with different users and applications in mind. We'll cover magnification, \
                        field of view, intended use cases, and the advantages of each platform so you can make an informed decision.<br/>\
                        In This Video:<br/>\
                        ThermNight thermal scope overview<br/>\
                        Hydra thermal scope overview<br/>\
                        Key differences between ThermNight and Hydra<br/>\
                        Best applications for each optic<br/>\
                        Choosing the right thermal scope for your setup<br/>\
                        Whether you're new to thermal imaging or looking to upgrade your current hunting optics, understanding the strengths of each system will help you get better \
                        performance in the field.<br/>\
                        Subscribe for more thermal scope guides, night vision training, and hunting optics education.",
                    matchProduct:'HS219,HS335R,TNC635R',
                    matchSeries:'ThermNight,Hydra',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/xrxoK-n9Pok?si=3QtRHeamYq6tPg77?enablejsapi=1&autoplay=1',
                    title:'ZULUS V2 vs ZULUS 4K vs NVMD-C200 | 50-1000 Yard Night Vision Comparison',
                    poster:'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/yourub-poster.webp?v=1780361497',
                    id:'Academy02',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Trying to choose between the ZULUS V2 vs ZULUS 4K vs NVMD-C200?<br/>\
                                We put all three to the test from 50 to 1000+ yards across a full range of real-world lighting conditions.<br/>\
                                In this episode of DNT Academy, we run a side-by-side comparison of our digital night vision lineup to show exactly how each optic performs from close range all the way out to extreme distance — in daylight, low light, and complete darkness.<br/>\
                                The goal here isn’t to pick a winner. It’s to show what each optic is built for, so you can choose what best fits your setup, shooting style, budget, and target.<br/>\
                                Chapters<br/>\
                                00:00 Intro<br/>\
                                00:29 Day Mode 50 Yards<br/>\
                                01:34 Day Mode 100 Yards<br/>\
                                02:20 Day Mode 300 Yards<br/>\
                                03:57 Day Mode 600 Yards<br/>\
                                04:35 Day Mode 1000 Yards<br/>\
                                05:25 Low Light Day Mode 50 Yards<br/>\
                                06:11 Low Light IR Off 50 Yards<br/>\
                                06:28 Low Light IR On 50 Yards<br/>\
                                07:11 No Light IR On 100 Yards<br/>\
                                07:30 No Light IR On 300 Yards<br/>\
                                08:28 No Light IR On 1000 Yards<br/>\
                                09:52 Deer at 1200 Yards<br/>\
                                10:14 Outro",
                    matchProduct:'ZULUS 4K,NVMD-C200,ZHD520-V2',
                    matchSeries:'ZULUS-V2,ZULUS-4K,NVMD',
                    matchModle:''
                },
                {
                    iframeUrl:'https://www.youtube.com/embed/PGa7AU_8FtI?si=500oi_HaI7xSsM4C?enablejsapi=1&autoplay=1',
                    title:'DNT Optics Lineup Explained | Thermal & Digital Night Vision',
                    poster:'https://cdn.shopify.com/s/files/1/0706/6776/3947/files/d5d68978b20d42d98aa883b8f232390a.webp?v=1780362034',
                    id:'Academy01',
                    type:'Academy',
                    source:'yuotubo',
                    descrption:"Choosing the right optic can be confusing.<br/>\
                                Thermal. Digital night vision. Rangefinders. Ballistic calculators. All of them.<br/>\
                                What do you actually need?<br/>\
                                In this video we break down the entire DNT Optics lineup and explain the purpose of each system so you can choose the right optic for your setup and your style of hunting.<br/>\
                                We cover:<br/>\
                                • Thermal scopes and their advantages<br/>\
                                • Digital day/night vision optics<br/>\
                                • Rangefinding features<br/>\
                                • Ballistic calculator integrations<br/>\
                                • Key differences between models<br/>\
                                Whether you're chasing hogs, predators, or shooting at night, understanding the differences between optics will help you make a better decision.<br/>\
                                If you're new to thermal or night vision, this video is the best place to start.<br/>\
                                Welcome to DNT Academy.",
                    matchProduct:'ZULUS 4K,NVMD-C200,TNC635R',
                    matchSeries:'ThermNight,Hydra,ZULUS,ZULUS-V2,HOUND,ZULUS-4K,NVMD',
                    matchModle:''
                },
            ]
        },
        {
            name:'Field Notes',
            type:'Field_Notes',
            data: [
                {
                    iframeUrl:'https://www.youtube.com/embed/2I5J__ZSdLU?si=6a9kNhNtM90Lavvw?enablejsapi=1&autoplay=1',
                    title:'Turkey Hunting Q&A | Setups, Mouth Calls & Calling Tips',
                    poster:'https://i.ytimg.com/vi/2I5J__ZSdLU/hq720.jpg?sqp=-oaymwEnCNAFEJQDSFryq4qpAxkIARUAAIhCGAHYAQHiAQoIGBACGAY4AUAB&rs=AOn4CLCiN6_KKUTOlXMhBPwOFpE0IO-tIQ',
                    id:'Field_Notes01',
                    type:'Field_Notes',
                    source:'yuotubo',
                    descrption:"In this comprehensive Q&A guide, Clay McEachern breaks down the core gear and tactical decisions required for a successful turkey hunt. 🦃<br/>\
                    Learn the real-world impact of shotgun chokes and gauges, how the NVMD-C200 can help reduce common aiming errors in close-range turkey hunting, the process of \
                    selecting the right diaphragm call cut, and advanced calling strategies to close the distance on hung-up birds.<br/>\
                    Chapters:<br/>\
                    00:00 Intro<br/>\
                    00:17 How to Choose the Right Weapon for Turkey Hunting<br/>\
                    01:13 How to Choose the Right Optic for Turkey Hunting<br/>\
                    02:47 How to Use a Mouth Call/Diaphragm Call<br/>\
                    04:52 How to Close the Distance and Use Decoy Sounds Effectively<br/>\
                    06:28 Pro Turkey Hunting Tips & Field Strategies<br/>\
                    07:39 Outro<br/>\
                    Whether you're a new or experienced hunter, this video delivers practical insights into turkey hunting gear, calling strategies, and real-world hunting decisions.<br/>\
                    Discover more on our official website: <a href='https://us.dntoptics.com/'>https://us.dntoptics.com/</a> ",
                    matchProduct:'NVMD-C200',
                    matchSeries:'NVMD',
                    matchModle:'NVMD-C200'
                },
            ]
        }
    ]